<template>
	<div class="indexView">
		<div class="m-hd box align-center">
			<div class="col-1">
				<img src="../common/images/user-hd.png">
			</div>
			<div class="col-2 flex-1">
				<p class="userName" @click="dialog = true" v-if="name == ''||name == 'undefined'">设置昵称</p>
				<p class="userName" v-else>{{name}}</p>
				<p class="phone">{{fmtMobile}}</p>
			</div>
			<div class="col-3"><i class="iconfont icon-arrow-left" v-if="name == ''||name == 'undefined'" @click="dialog = true"></i></div>
		</div>
		<div class="m-navs">
			<div class="row-control mb20">
				<router-link :to="{name:'commentView'}" tag="div" class="row">
					<i class="iconfont">&#xe6a8;</i>
					<p>我的评论</p>
					<i class="iconfont icon-arrow-left"></i>
				</router-link>
				<router-link :to="{name:'opinionView'}"  tag="div" class="row">
					<i class="iconfont">&#xe61b;</i>
					<p>反馈意见</p>
					<i class="iconfont icon-arrow-left"></i>
				</router-link>
			</div>
			<div class="row-control">	
				<router-link :to="{name:'memberAbout'}" tag="div" class="row">
					<i class="iconfont">&#xe63e;</i>
					<p>关于</p>
					<i class="iconfont icon-arrow-left"></i>
				</router-link>
			</div>
			<div class="row-control logOut">
				<div class="row" @click = "logOut">
					退出登陆
				</div>
			</div>
			
		</div>
		<div class="setName m-dialog" v-show="dialog">
			<div class="mask"></div>
			<div class="modal">
				<div class="modal-hd box">
					<h3>设置昵称</h3><span>（昵称仅能设置一次）</span>
				</div>
				<div class="modal-bd">
					<form method="post" @submit.prevent="onSubmit()">
						<div class="input-group">
							<input type="text" placeholder="请输入您的昵称" v-model.trim="setName" @blur.prevent = "blursetName">
						</div>
						<div class="btn-bar">   
							<input type="submit" class="submit" :disabled="isDisabled"
		            :class="{disabled: isDisabled}" value="确认">
						</div>
					</form>
				</div>
				<div class="iconfont icon-close modal-close" @click="dialog = false"></div>
			</div>
		</div>
		<tip :msgControl="msgShow"><p slot="content">{{tipText}}</p></tip>
	</div>
</template>
<script>
import tip from '../components/tip.vue'
import {getCookie,httpHead} from '../common/util/config.js'
export default {
	created () {
		let cookie = document.cookie;
		this.mobile = getCookie(cookie,'mobile');
		this.token = getCookie(cookie,'token');
		this.name = decodeURIComponent(getCookie(cookie,'name'));
		httpHead.token = this.token
		// console.log(httpHead)
	},
	data () {
		return {
			mobile: '',
			token: '',
			name: '',
			setName: '',
			isDisabled: false,
			dialog: false,
			msgShow: false,
			tipText: '',
			nameState: false
		}
	},
	methods: {
		msg (){
			this.msgShow =true;
			clearTimeout(this.timeOut);
			this.timeOut = setTimeout(() => {
               this.msgShow =false;
			}, 2000)
		},
		blursetName () {
			if(this.setName == ''){
				this.msg()
				this.tipText = "请输入昵称";
				this.nameState = false;
			}
			else if(this.setName.length<2){
				this.msg()
				this.tipText = "昵称最少输入2位";
				this.nameState = false;
			}
			else if(this.setName.length>16){
				this.msg()
				this.tipText = "昵称最多输入16位";
				this.nameState = false;
			}
			else if(!/^[\u4e00-\u9fa5_a-zA-Z0-9]{2,16}$/.test(this.setName)){
				this.msg()
				this.tipText = "昵称只允许汉字、字母、数字和下划线及破折号";
				this.nameState = false;
			}else {
				this.nameState = true;
			}
		},
		onSubmit (){
			this.isDisabled = true;
			if(this.nameState ==false){
				this.msg()
				this.tipText = "请核对后再提交"
				this.isDisabled = false;
				return false
			}
			this.$post('api/upuser',{'user_nickname': this.setName})
			.then( res => {
				console.log(res)
				if(res.code == 200){
					this.msg()
					this.tipText = "修改成功"
					document.cookie="name="+encodeURIComponent(this.setName);
					this.name = this.setName;
					this.dialog = false
				}else {
					this.msg()
					this.tipText = res.msg;
					this.isDisabled = false;
				}
			})
		},
		logOut () {
			document.cookie = "mobile=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
			document.cookie = "name=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
			document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
			this.msg()
			this.tipText = '退出成功';
			setTimeout(() => {
				this.$router.push({ name: 'homeView'});
			}, 2000);
		}
	},
	computed:{
		fmtMobile () {
			let mobile = this.mobile.substr(0,3)+'****'+this.mobile.substr(7,4);
			return mobile;
		}
	},
	// beforeRouteEnter (to, from, next) {
	// 	next(vm => {
	// 		let cookie = document.cookie;
	// 		let mobile = getCookie(cookie,'mobile');
	// 		let token = getCookie(cookie,'token');
	// 	    if(mobile == undefined || token == undefined){
	// 	    	vm.$router.push({ name: 'loginView'})
	// 	    }
	// 	})
	// },
	components:{
		tip
	}
}
</script>
<style lang="scss">
.indexView{
	.m-hd{
		height: 2.9rem;
		padding: 0 .4rem;
		background: #3c3c3c;
		.col-1{
			width: 1.4rem;
			margin-right:.3rem;
		}
		.col-2{
			color:#fff;
			font-size:.24rem;
		}
		.userName{
			font-size:.36rem;
			margin-bottom:.3rem;
		}
		.iconfont{
			font-size:.5rem;
			color:#fff;
		}
	}
	.m-navs{
		.row-control{
			background:#fff;
			padding:0 .4rem;
			.row{
				display:flex;
				height: 1rem;
				align-items: center;
				border-bottom:1px solid #dddddd;
				color:#333;
				&:last-child{
					border-bottom:none;
				}
				.iconfont{
					font-size:.5rem;
					margin-right:.2rem;
				}
				.icon-arrow-left{
					font-size:.36rem;
					margin-right:0;
				}
				p{
					flex:1;
					font-size:.28rem;
				}
			}
		}
		.logOut{
			margin-top:2rem;
			.row{
				display:flex;
				height: 1rem;
				text-align:center;
				justify-content: center;
				font-size:.28rem;
				align-items: center;
				color:#e33333;
				background:#fff;
			}
		}
		
	}
	.m-dialog{
		position:fixed;
		top:0;
		bottom:0;
		left:0;
		right:0;
		.mask{
			position:absolute;
			width: 100%;
			height: 100%;
			background:rgba(0,0,0,0.6);
		}
		.modal{
			position:absolute;
			width: 85%;
			top:50%;
			left:50%;
			transform:translate(-50%,-70%);
			background:#fff;
			padding:.5rem;
			box-sizing:border-box;
			border-radius:.1rem;
			.modal-hd{
				margin-bottom:.7rem;
				height:.4rem;
				line-height:.4rem;
				h3{
					font-size:.36rem;
					font-weight:normal;
				}
				span{
					font-size:.22rem;
					line-height:.5rem;
				}
			}
			.modal-bd{
				input{
					width: 100%;
					border:none;
					height: .55rem;
					line-height:.55rem;
					border-bottom:1px solid #dddddd;
					outline: none;
					padding:0;
				}
				.btn-bar{
					margin-top:.6rem;
					.submit{
						background: linear-gradient(to bottom, #799ff2 , #2451b3);
						border:none;
						padding:0;
						color:#fff;
						display:block;
						margin:0 auto;
						height: .8rem;
						border-radius:.4rem;
						outline: none;
						font-size:.36rem;
					} 
				}
			}
			.modal-close{
				position:absolute;
				bottom:-1.5rem;
				left:50%;
				width: .64rem;
				height: .64rem;
				line-height: .64rem;
				transform:translateX(-50%);
				color:#fff;
				font-size:.4rem;
				border-radius:50%;
				border:1px solid #fff;
				text-align: center;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/page/memberIndex.vue